export default __webpack_public_path__ + "static/media/loader.6c308726.png";